import { useState } from 'react';

import { ButtonProps } from '@mui/material';

import { DialogButton } from '@/components/Dialog';

interface DisableableButtonProps extends ButtonProps {
  clickCallback: () => void;
  disabledProp?: boolean;
}
export const LockingDisableButton = (props: DisableableButtonProps) => {
  const [disabled, setDisabled] = useState(false);
  const { clickCallback, disabledProp, ...buttonProps } = props;
  const children = props.children;
  return (
    <DialogButton
      onClick={() => {
        setDisabled(true);
        clickCallback();
      }}
      {...buttonProps}
      disabled={disabledProp || disabled}
    >
      {children}
    </DialogButton>
  );
};
